import React from 'react';
import { Email, Textsms } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface Props {
  sendSms: boolean;
  sendEmail: boolean;
}

export const DeliveryMethods = ({ sendSms, sendEmail }: Props): JSX.Element => {
  return (
    <Stack direction="row" spacing={1}>
      {sendSms && (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Textsms sx={{ fontSize: 14, color: 'grey.600' }} />
          <Typography>Text</Typography>
        </Stack>
      )}
      {sendEmail && (
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Email sx={{ fontSize: 14, color: 'grey.600' }} />
          <Typography>Email</Typography>
        </Stack>
      )}
    </Stack>
  );
};
